import { storeOrUpdateTeamTarget } from '@/api/teamTarget'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        targetModel: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: {span: 5},
            wrapperCol: {span: 17},
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                name: [{required: true, message: '请选择小组', trigger: 'change'}],
                month: [{required: true, message: '请选择月份', trigger: 'change'}],
                target: [{required: true, message: '请填写消耗目标', trigger: 'change'}],
            },
            platforms:[],
        }
    },
    computed: {
        actType() {
            return this.targetModel.id ? '修改' : '添加'
        }
    },
    mounted() {
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.targetModel)
            this.loading = true
            storeOrUpdateTeamTarget(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.targetModel.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        }
    }
}
